module.exports = __webpack_public_path__ + "static/nextGrey-4713fbcfc4d5f2978bc49645f48ac751.png";